export default __webpack_public_path__ + "static/icon-16-5-993486646b9c178481559545ba5c9efe.png";